import cssVars from "css-vars-ponyfill";
import { STORAGE, ThemeKey, ThemeKeyType, ThemeMap } from "../constants";
import { URLSearchParamsHelper } from "../utils/url-search";
import { getCustomInfo } from "../utils/get-custom-info";

export function getCurrentTheme(): ThemeKeyType {
  const location = window.location;
  const urlSearchParamsHelper = new URLSearchParamsHelper(location.search);
  const custom =
    urlSearchParamsHelper.get("custom") || getCustomInfo().cumtomMode;
  if (urlSearchParamsHelper.get("channel") === "3" && custom === 'client') { // chanel为3表示是效果图客户端
    return 'picture_client';
  }
  if (Object.values(ThemeKey).includes(custom)) {
    return custom;
  }
  const isFox = location.host.includes(ThemeKey.foxrenderfarm);
  if (custom === "client") {
    return isFox ? ThemeKey.foxrenderfarm_client : ThemeKey.renderbus_client;
  }
  return isFox ? ThemeKey.foxrenderfarm : ThemeKey.renderbus;
}

export function switchTheme(theme: ThemeKeyType = ThemeKey.renderbus) {
  document.body.dataset.theme = theme;
  cssVars({
    variables: ThemeMap.get(theme),
  });
}
